import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Eye } from "react-feather";

const sapUnpaidInvoicesTableColumn = [
    {
        Header: "S.no",
        id: "s_no",
        width: "75",
    },
    {
        Header: "Sales Employee",
        accessor: "sales_employee",
    },
    {
        Header: "BP Code",
        accessor: "bp_code",
    },
    {
        Header: "BP Name",
        accessor: "bp_name",
        width: "500",
    },
    {
        Header: "Group",
        accessor: "group",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "Doc No",
        accessor: "doc_number",
    },
    {
        Header: "Posting Date",
        accessor: "posting_date",
    },
    {
        Header: "Due Date",
        accessor: "due_date",
    },
    {
        Header: "Document Date",
        accessor: "document_date",
    },
    {
        Header: "BP Ref No",
        accessor: "bp_ref_number",
    },
    {
        Header: "Balance Due",
        accessor: "balance_due",
    }
];

export { sapUnpaidInvoicesTableColumn };
